import React, { useState, useEffect } from "react";

import TemplateGrid from "./components/TemplateGrid/TemplateGrid";
import TemplateHeader from "./components/TemplateHeader/TemplateHeader";
import { createMuiTheme } from "@material-ui/core/styles";
import { ThemeProvider } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";
import CompletedView from "./components/CompletedView/CompletedView";
import AssignedView from "./components/AssignedView/AssignedView";
import ArchiveView from "./components/ArchiveView/ArchiveView";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";

import { useNavigate } from "react-router-dom";
import Loading from "Components/loading";
import { validateMagicLink } from "Helpers/call_apis";
import {
	saveMagicLinkSession,
	clearMagicLinkSessionIfExpired,
	isMagicLinkSession,
	syncMagicLinkSessionFromValidate,
} from "Services/docForm.service";
const useStyles = makeStyles((theme) => ({
	container: {
		display: "flex",
		flexDirection: "column",
		minHeight: "90vh",
	},
	explorerContainer: {
		display: "flex",
		flexDirection: "column",
		width: "100%",
		overflowY: "auto",
		backgroundColor: "#f0f0f0",
		flex: 1,
		height: "100%",
	},
}));
const theme = createMuiTheme({
	palette: {
		primary: {
			main: "#006ac6",
		},
		secondary: {
			main: "#009A17",
		},
		green: {
			main: "#009A17",
		},
	},
	typography: {
		fontFamily: ["Roboto", "Helvetica", "sans-serif"].join(","),
	},
});
const DocForms = () => {
	const classes = useStyles();
	const [startPage] = useState(true);
	const dispatch = useDispatch();
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(50);
	const [valueSearch, setValueSearch] = useState("");
	const navigate = useNavigate();
	const notify = (msj, event) => toast[event](msj);
	const [loading, setLoading] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState("Processing...");

	const [mpage, setMPage] = useState(0);
	const [tabValue, setTabValue] = React.useState(0);
	const [magicLinkFlow, setMagicLinkFlow] = useState(() => {
		const params = new URLSearchParams(window.location.search);
		return Boolean(params.get("token"));
	});

	const handleTabChange = (newValue) => {
		setTabValue(newValue);
	};

	useEffect(() => {
		if (startPage) {
			if (clearMagicLinkSessionIfExpired()) {
				notify("Your secure link has expired. Ask the sender for a new link.", "info");
			}

			const params = new URLSearchParams(window.location.search);
			const token = params.get("token");
			if (token) {
				// Clear stale session so validate is not sent with an old Bearer token
				localStorage.removeItem("esignature");

				// Validate the magic link token
				setLoadingPage(true, "Validating magic link...");
				validateMagicLink(token)
					.then((response) => {
						const payload = response?.data?.data ?? response?.data;
						if (payload?.is_valid === true) {
				

							console.log("response validateMagicLink", response);
							const signerEmail = payload?.user_email || null;
							const displayName =
								payload?.user_name ||
								signerEmail?.split("@")?.[0] ||
								"";
							if (!signerEmail) {
								notify("Could not resolve signer email for this link", "error");
								setTimeout(() => navigate("/"), 3000);
								return;
							}

							saveMagicLinkSession({ token, payload, signerEmail, displayName });
							window.history.replaceState({}, "", window.location.pathname);

							const alreadySubmitted =
								payload?.has_been_used === true ||
								payload?.form_completed === true;

							setMagicLinkFlow(false);

							if (alreadySubmitted) {
								setTabValue(1);
								notify(
									"Your submitted form is highlighted under Completed.",
									"info"
								);
							} else {
								setTabValue(0);
								notify(
									"The form from your email link is highlighted under Assigned.",
									"info"
								);
							}
						} else {
							console.error("Magic link has expired", response);
							notify("Invalid or expired magic link", "error");
							setTimeout(() => {
								navigate("/");
							}, 3000);
						}
						// Navigate to home page after successful authentication

					})
					.catch((error) => {
						console.error("Magic link validation failed:", error);
						notify("Invalid or expired magic link", "error");
						// Handle validation failure
						setTimeout(() => {
							navigate("/");
						}, 3000);
					})
					.finally(() => {
						setLoadingPage(false);
					});
			} else if (isMagicLinkSession()) {
				syncMagicLinkSessionFromValidate();
			}
		}
	}, [startPage]);
	const setLoadingPage = (loading, message = "Processing...") => {
		setLoading(loading);
		setLoadingMessage(message);
	};
	// While handling ?token=..., do not mount inbox views (they call gateway-only APIs).
	if (magicLinkFlow) {
		return <Loading show={loading} text={loadingMessage} />;
	}

	return (
		<div>
			<Loading show={loading} text={loadingMessage} />
			<ThemeProvider theme={theme}>
				<div className={classes.container}>
					<TemplateHeader tabValue={tabValue} onTabChange={handleTabChange} />

					<div className={classes.explorerContainer}>
						{/* {tabValue === 0 && (
						<TemplateGrid
							setLoading={setLoadingPage}
							reloadTemplates={() => {}}
						/>
					)} */}
						{!magicLinkFlow && tabValue === 0 && (
							<AssignedView setLoading={setLoadingPage} onViewCompleted={() => setTabValue(1)} />
						)}
						{!magicLinkFlow && tabValue === 1 && (
							<CompletedView setLoading={setLoadingPage} />
						)}
						{/* {tabValue === 3 && <ArchiveView setLoading={setLoadingPage} />} */}
					</div>
					<ToastContainer autoClose={3000} />
				</div>
			</ThemeProvider>
		</div>
	);
};

export default DocForms;
